module.exports = __webpack_public_path__ + "img/3.40e308f2.png";